import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  BuildingOfficeIcon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  GiftIcon,
  PlusIcon
} from '@heroicons/react/24/outline';

const AgentBottomNav = () => {
  const location = useLocation();

  const navigation = [
    { 
      name: 'דשבורד', 
      href: '/agent', 
      icon: HomeIcon, 
      exact: true 
    },
    { 
      name: 'חברות', 
      href: '/agent/companies', 
      icon: BuildingOfficeIcon 
    },
    { 
      name: 'יעדים', 
      href: '/agent/targets', 
      icon: ChartBarIcon 
    },
    { 
      name: 'הזמנות', 
      href: '/agent/orders', 
      icon: ClipboardDocumentListIcon 
    },
    { 
      name: 'חבילות', 
      href: '/agent/bundles-discounts', 
      icon: GiftIcon 
    }
  ];

  const isActive = (item) => {
    if (item.exact) {
      return location.pathname === item.href;
    }
    return location.pathname.startsWith(item.href);
  };

  return (
    <>
      {/* Bottom Navigation Bar - Only on tablets/mobile */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg md:hidden">
        <div className="flex items-center justify-around py-2 px-1">
          {navigation.map((item) => {
            const Icon = item.icon;
            const active = isActive(item);
            
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`flex flex-col items-center justify-center py-2 px-3 rounded-lg transition-all touch-manipulation min-h-[60px] ${
                  active
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-gray-600 hover:bg-gray-50'
                }`}
              >
                <Icon className={`h-6 w-6 mb-1 ${active ? 'text-primary-600' : 'text-gray-500'}`} />
                <span className={`text-xs font-medium ${active ? 'text-primary-600' : 'text-gray-500'}`}>
                  {item.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>

    </>
  );
};

export default AgentBottomNav;
